import * as React from "react";
import { NavLink, Route } from "react-router-dom";
import StudyList from "./page/study-list/StudyList";
import "./app.scss";
import ReportList from "./page/report-list/ReportList";
import MessageBar from "./component/messagebar/MessageBar";
import { AuthContext, AuthParent } from "./component/auth/AuthContext";
import LabelizeObs from "./page/labelize/Labelize";
import TaskList from "./page/task-list/TaskList";
import { Collapse, Nav, Navbar, NavItem } from "reactstrap";
import LabelizePartParam from "./page/labelize-part-param/Labelize-part-param";
import LabelizeWelcome from "./page/labelize-welcome/LabelizeWelcome";
import GroundTruthWorkflow from "./page/ground-truth/GroundTruthWorkflow";
import GroundTruthWelcome from "./page/ground-truth/GroundTruthWelcome";
import GroundTruthReconcileWorkflow from "./page/ground-truth/GroundTruthReconcileWorkflow";
import DemoStudyList from "./page/demo-study-list/DemoStudyList";
import ReaderWelcome from "./page/reader/ReaderWelcome";
import ReaderWorkflow from "./page/reader/ReaderWorkflow";
import i18n from "i18next";

localStorage.setItem("debug", "cornerstoneTools");

const App = () => (
  <main>
    <MessageBar />

    <AuthParent>
      <AuthContext.Consumer>
        {(auth) => (
          <div>
            <Navbar className="main justify-content-between" color="dark" dark expand>
              <Collapse isOpen={false} navbar>
                <Nav className="mr-auto" navbar>
                  {auth.hasRole("ADMIN") && (
                    <NavItem>
                      <NavLink className="nav-link" to="/study">
                        Study
                      </NavLink>
                    </NavItem>
                  )}
                  {auth.hasRole("ADMIN") && (
                    <NavItem>
                      <NavLink className="nav-link" to="/typed-reports">
                        {i18n.t("global.report")}
                      </NavLink>
                    </NavItem>
                  )}
                  {auth.hasRole("ADMIN") && (
                    <NavItem>
                      <NavLink className="nav-link" to="/tasks">
                        {i18n.t("global.task")}
                      </NavLink>
                    </NavItem>
                  )}
                  {auth.hasAnyRole(["ADMIN", "RAD", "LABEL"]) && (
                    <NavItem>
                      <NavLink className="nav-link" to="/labelize">
                        Labelize
                      </NavLink>
                    </NavItem>
                  )}
                  {auth.hasAnyRole(["ADMIN", "EVAL_GT"]) && (
                    <NavItem>
                      <NavLink className="nav-link" to="/ground-truth">
                        Ground Truth
                      </NavLink>
                    </NavItem>
                  )}
                  {auth.hasAnyRole(["ADMIN", "EVAL_RD"]) && (
                    <NavItem>
                      <NavLink className="nav-link" to="/reader">
                        Reader
                      </NavLink>
                    </NavItem>
                  )}
                  {auth.hasAnyRole(["ADMIN", "DEMO"]) && (
                    <NavItem>
                      <NavLink className="nav-link" to="/demo-studies">
                        Demo
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                <Nav navbar className="ml-auto">
                  <button className="btn btn-secondary" onClick={() => auth.logout()}>
                    {i18n.t("global.logout")}
                  </button>
                </Nav>
              </Collapse>
            </Navbar>
            {/* Routes declaration */}
            <div>
              <Route path="/ground-truth" render={(props) => <GroundTruthWelcome {...props} authManager={auth} />} />
              <Route
                path="/ground-truth-workflow"
                render={(props) => <GroundTruthWorkflow {...props} authManager={auth} />}
              />
              <Route
                path="/ground-truth-rec-workflow"
                render={(props) => <GroundTruthReconcileWorkflow {...props} authManager={auth} />}
              />
              <Route path="/reader" render={(props) => <ReaderWelcome {...props} authManager={auth} />} />
              <Route path="/reader-workflow" render={(props) => <ReaderWorkflow {...props} authManager={auth} />} />
              <Route path="/labelize" render={(props) => <LabelizeWelcome {...props} authManager={auth} />} />
              <Route path="/labelize-obs" render={(props) => <LabelizeObs {...props} authManager={auth} />} />
              <Route
                path="/labelize-part-params"
                render={(props) => <LabelizePartParam {...props} authManager={auth} />}
              />
              <Route path="/study" render={(props) => <StudyList {...props} authManager={auth} />} />
              <Route exact path="/typed-reports" render={(props) => <ReportList {...props} authManager={auth} />} />
              <Route exact path="/tasks" render={(props) => <TaskList {...props} authManager={auth} />} />
              <Route path="/demo-studies" render={(props) => <DemoStudyList {...props} authManager={auth} />} />
            </div>
          </div>
        )}
      </AuthContext.Consumer>
    </AuthParent>
  </main>
);

export default App;
